import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=1cfc6374&"
import script from "./manage.vue?vue&type=script&lang=js&"
export * from "./manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cfc6374')) {
      api.createRecord('1cfc6374', component.options)
    } else {
      api.reload('1cfc6374', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=1cfc6374&", function () {
      api.rerender('1cfc6374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/manage.vue"
export default component.exports